import { API_endpoints } from "./config";

export const getallKids = async (id = null): Promise<any> => {
    try {
        const body = {};

        const response = await fetch(API_endpoints.getallKids, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Kinderdaten .");
        }

        return await response.json();
        
    } catch (error) {
        console.error("Fehler beim Laden von Kinderdaten:", error);
    }
};